"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LANGUAGE_SELECTED_STORAGE_KEY = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _classnames = _interopRequireDefault(require("classnames"));

var _NestedDropdown = _interopRequireDefault(require("@insided/shared/uikit/NestedDropdown"));

var _dropdown = _interopRequireDefault(require("@insided/shared/uikit/dropdown"));

var _NestedDropdownHeader = _interopRequireDefault(require("@insided/shared/uikit/NestedDropdown/NestedDropdownHeader"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LANGUAGE_SELECTED_STORAGE_KEY = 'languageSelected';
exports.LANGUAGE_SELECTED_STORAGE_KEY = LANGUAGE_SELECTED_STORAGE_KEY;

function mapLanguagesToNestedDropdownItem(languages) {
  return languages.map(function (language) {
    return {
      id: language.id,
      title: "".concat(language.name).concat(language.isDefault ? ' (Default)' : ''),
      children: []
    };
  });
}

var LanguageSelector = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LanguageSelector, _Component);

  var _super = _createSuper(LanguageSelector);

  function LanguageSelector() {
    var _this;

    (0, _classCallCheck2.default)(this, LanguageSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", _this.getInitialState());
    return _this;
  }

  (0, _createClass2.default)(LanguageSelector, [{
    key: "getInitialState",
    value: function getInitialState() {
      var _this$props$community;

      var storedLanguageSelected = sessionStorage.getItem(LANGUAGE_SELECTED_STORAGE_KEY);

      if (storedLanguageSelected && !this.props.resetSelectedLanguage) {
        var selectedLanguage = JSON.parse(storedLanguageSelected);
        return {
          selectedLanguage: selectedLanguage
        };
      }

      return {
        selectedLanguage: {
          id: (_this$props$community = this.props.communityLanguage) === null || _this$props$community === void 0 ? void 0 : _this$props$community.id,
          title: this.props.communityLanguage ? "".concat(this.props.communityLanguage.name).concat(this.props.communityLanguage.isDefault ? ' (Default)' : '') : '',
          value: this.props.communityLanguage ? this.props.communityLanguage.code : ''
        }
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.resetSelectedLanguage) {
        var communityLanguage = this.props.communityLanguage;

        if (communityLanguage) {
          this.onLanguageSelected(communityLanguage === null || communityLanguage === void 0 ? void 0 : communityLanguage.id);
        }
      }
    }
  }, {
    key: "findLanguageById",
    value: function findLanguageById(languageId) {
      var _this$props = this.props,
          enabledLanguages = _this$props.enabledLanguages,
          publishedLanguages = _this$props.publishedLanguages;
      var foundEnabledLanguage = enabledLanguages === null || enabledLanguages === void 0 ? void 0 : enabledLanguages.find(function (language) {
        return language.id === languageId;
      });
      if (foundEnabledLanguage) return foundEnabledLanguage;
      var foundPublishedLanguage = publishedLanguages === null || publishedLanguages === void 0 ? void 0 : publishedLanguages.find(function (language) {
        return language.id === languageId;
      });
      if (foundPublishedLanguage) return foundPublishedLanguage;
      return undefined;
    }
  }, {
    key: "onLanguageSelected",
    value: function onLanguageSelected(languageId) {
      if (languageId === null) return;
      var onLanguageSelected = this.props.onLanguageSelected;
      var language = this.findLanguageById(String(languageId));

      if (language) {
        this.setState({
          selectedLanguage: {
            id: language.id,
            title: "".concat(language.name).concat(language.isDefault ? ' (Default)' : ''),
            value: language.code
          }
        });
        var selectedLanguage = this.state.selectedLanguage;
        window.sessionStorage.setItem(LANGUAGE_SELECTED_STORAGE_KEY, JSON.stringify(selectedLanguage));
        onLanguageSelected === null || onLanguageSelected === void 0 ? void 0 : onLanguageSelected(language.code);
      }
    }
  }, {
    key: "getUnpublishedLanguageOptions",
    value: function getUnpublishedLanguageOptions(enabledLanguages) {
      var _this2 = this;

      var enabledLanguagesDropdownItems = mapLanguagesToNestedDropdownItem(enabledLanguages);
      return (0, _preact.h)("div", {
        key: "Unpublished Languages"
      }, (0, _preact.h)(_NestedDropdownHeader.default, null, "Unpublished Languages"), (0, _preact.h)(_NestedDropdown.default, {
        items: enabledLanguagesDropdownItems,
        onSelectItem: function onSelectItem(languageId) {
          return _this2.onLanguageSelected(languageId);
        },
        depth: 1
      }));
    }
  }, {
    key: "getPublishedLanguageOptions",
    value: function getPublishedLanguageOptions(publishedLanguages) {
      var _this3 = this;

      var publishedLanguagesDropdownItems = mapLanguagesToNestedDropdownItem(publishedLanguages);
      return (0, _preact.h)("div", {
        key: "Published Languages"
      }, (0, _preact.h)(_NestedDropdownHeader.default, null, "Published Languages"), (0, _preact.h)(_NestedDropdown.default, {
        items: publishedLanguagesDropdownItems,
        onSelectItem: function onSelectItem(languageId) {
          return _this3.onLanguageSelected(languageId);
        },
        depth: 1
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _enabledLanguages$fil,
          _this4 = this,
          _publishedLanguages$f;

      var selectedLanguage = this.state.selectedLanguage;
      var _this$props2 = this.props,
          enabledLanguages = _this$props2.enabledLanguages,
          publishedLanguages = _this$props2.publishedLanguages,
          fill = _this$props2.fill,
          width = _this$props2.width;
      var filteredEnabledLanguages = (_enabledLanguages$fil = enabledLanguages === null || enabledLanguages === void 0 ? void 0 : enabledLanguages.filter(function (language) {
        return language.id !== _this4.state.selectedLanguage.id;
      })) !== null && _enabledLanguages$fil !== void 0 ? _enabledLanguages$fil : [];
      var filteredPublishedLanguages = (_publishedLanguages$f = publishedLanguages === null || publishedLanguages === void 0 ? void 0 : publishedLanguages.filter(function (language) {
        return language.id !== _this4.state.selectedLanguage.id;
      })) !== null && _publishedLanguages$f !== void 0 ? _publishedLanguages$f : [];
      var hasEnabledLanguages = filteredEnabledLanguages.length > 0;
      var hasPublishedLanguages = filteredPublishedLanguages.length > 0;
      if (!hasEnabledLanguages && !hasPublishedLanguages) return null;
      var unpublishedLanguageOptions = hasEnabledLanguages ? this.getUnpublishedLanguageOptions(filteredEnabledLanguages) : null;
      var publishedLanguageOptions = hasPublishedLanguages ? this.getPublishedLanguageOptions(filteredPublishedLanguages) : null;
      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('language-selector-container', 'dropdown-container', {
          fill: fill,
          fixedWidth: width
        }),
        style: width ? "--language-selector-width: ".concat(width) : ''
      }, (0, _preact.h)(_dropdown.default, {
        closeOnDropdownClick: true,
        popupName: "language-selector-dropdown",
        className: "dropdown-selector",
        trigger: (0, _preact.h)(_Button.default, {
          title: selectedLanguage.title,
          endIcon: "chevronDown",
          size: "medium",
          fullWidth: true,
          "data-qa": "select-category"
        }),
        triggerClass: "dropdown-selector-wrapper--control"
      }, publishedLanguageOptions, unpublishedLanguageOptions));
    }
  }]);
  return LanguageSelector;
}(_preact.Component);

var _default = LanguageSelector;
exports.default = _default;